<template>
  <Teleport v-if="loaded" to="#layout_main">
    <ProgressBar v-if="loading" mode="indeterminate" style="height: .2em" />
  </Teleport>
  <main>
    <div v-if="loaded" class="grid dashboard">
      <chart-generator :chart="chart" v-for="chart in charts" :key="chart"></chart-generator>
    </div>
  </main>
</template>

<script>

import ChartGenerator from "../components/ChartGenerator";
import axiosClient from "@/axios";

export default {
  data() {
    return {
      loading: false,
      loaded: false,
      charts: []
    }
  },
  components: {
    ChartGenerator
  },
  watch: {
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      return axiosClient.get(`/chart/` + this.$route.params.layout)
        .then((res) => {
          this.loading = false;
          this.loaded = true;
          this.charts = res.data;
          return res;
        })
        .catch(error => {
          this.loading = false;
          return error;
        })
    }

  },
}
</script>
